if (!customElements.get('coupons-list')) {
  class CouponsList extends HTMLElement {
    connectedCallback () {
      this.couponCards = Array.from(this.querySelectorAll('[data-coupon-card]'));
      this.currentCode = (this.dataset.currentCode || '').trim();
    }

    update (newCode) {
      this.dataset.currentCode = (newCode || '').trim();
      this.currentCode = this.dataset.currentCode;

      const normalized = this.currentCode.toLowerCase();
      const couponStrings = (window.theme && window.theme.strings && window.theme.strings.coupons) || {};

      this.couponCards.forEach((card) => {
        const code = (card.dataset.code || '').trim();
        const isApplied = Boolean(code && normalized === code.toLowerCase());

        // 1. 更新 applied badge
        const badge = card.querySelector('[data-applied]');
        if (badge) {
          badge.classList.toggle('tw-hidden', !isApplied);
          badge.classList.toggle('tw-inline-flex', isApplied);
        }

        // 2. 更新按钮
        const actionBtn = card.querySelector('[data-coupon-action]');
        if (!actionBtn) return;

        const isIneligible = card.dataset.state === 'ineligible';

        if (isApplied) {
          card.dataset.state = 'applied';
          actionBtn.className = 'tw-text-xs tw-underline tw-text-black/70 tw-bg-transparent tw-border-0 tw-cursor-pointer js-remove-coupon';
          actionBtn.textContent = couponStrings.remove || 'Remove';
          actionBtn.disabled = false;
          actionBtn.dataset.action = 'remove';
        } else {
          card.dataset.state = isIneligible ? 'ineligible' : 'eligible';
          actionBtn.className = 'btn btn--primary btn--sm js-apply-coupon';
          actionBtn.textContent = couponStrings.apply || 'Apply';
          actionBtn.disabled = isIneligible;
          actionBtn.dataset.action = 'apply';
        }

        actionBtn.setAttribute('type', 'button');
        actionBtn.setAttribute('data-code', code);
      });
    }
  }

  customElements.define('coupons-list', CouponsList);
}